export const RUPEE_SYMBOL = '₹';
export const BACK = 'Back';
export const MY_HOLDINGS = 'My Holdings';
export const TRANSACTIONS = 'Transactions';
export const STATEMENTS = 'Statements';
export const EXPLORE_FUNDS = 'Explore Funds';
export const TermsAndConditions = 'Terms And Conditions';
export const COMING_SOON = 'Coming Soon...';
export const OTP_TIME_DURATION = 30;
export const NUM_OF_OTP_INPUTS = 6;
export const MONTHLY = 'MONTHLY';

export const NAV_PRECISION = 4;

export const monthNames = ['Jan', 'Feb', 'Ma', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const Months = [
  'January',
  'February',
  'March',
  'April',
  `May`,
  `June`,
  `July`,
  `August`,
  `September`,
  `October`,
  `November`,
  `December`,
];
export const durations = ['1M', '3M', '6M', '1Y', '3Y', '5Y'];
export const SLIDER_MIN_VALUE = 0;
export const SLIDER_MAX_VALUE = 20;
export const SLIDER_STEP = 2;

export const Confirm = 'Confirm';
export const Submit = 'Submit';
export const Cancel = 'Cancel';
export const Yes = 'Yes';
export const No = 'No';
export const Ok = 'Ok';

// export const INVESTMENT_TIME_FRAME_MAPPING = {
//   1: 'T4',
//   2: 'T5',
//   3: 'T6',
//   5: 'T7',
// };

export const INVESTMENT_TIME_FRAME_MAPPING = {
  'less than 3 months': 'T1',
  '3-9 months': 'T2',
  '9-12 months': 'T3',
  '12-18 months': 'T4',
  '18-24 months': 'T5',
  '2-3 years': 'T6',
  'greater than 3 years': 'T7',
};

//We get maxtimehorizon in T form but we need to display it in months and years format so to map it use this code
export const INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN = {
  T1: 'less than 3 months',
  T2: '3-9 months',
  T3: '9-12 months',
  T4: '12-18 months',
  T5: '18-24 months',
  T6: '2-3 years',
  T7: 'greater than 3 years',
};

export const AXIS_BANK_MEANING_MESSAGE =
  "Axis select is a curated list of mutual fund schemes. This is based on Axis Bank's proprietary research methodology and looks for consistently good historical returns on a risk adjusted basis over the medium term ";

// Regex
export const NUMBER_INPUT_ONLY = /^[0-9\b]+$/;
export const REGEX_NUMBER_INPUT_ONLY_STARTING_FROM_1 = /^[1-9]\d*$/;
export const REGEX_NUMBERS_ONLY_WITH_ONLY_4_DECIMAL = /^\d{1,20}(\.\d{0,4})?$/;
export const REGEX_NUMBERS_ONLY_WITH_ONLY_2_DECIMAL = /^\d{1,20}(\.\d{0,2})?$/;
export const CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY = /^[a-zA-Z0-9 ]*$/;
export const ADDRESS_INPUT_CHARACTERS = /^[a-zA-Z0-9 ,&$.`%!=*><?/();+{}@_:#]*$/;
export const CHARACTER_ONLY_REGEX = /^[A-Za-z]+$/;
export const CHARACTER_WITH_NO_SPACE = /^[^\s].+[^\s]$/;
export const ALPHA_NUMERIC_ONLY = /^[a-z0-9]+$/i;
// export const NO_BLANK_SPACES =/^[-_a-zA-Z0-9]+(\s+[-_a-zA-Z0-9]+)*$/;
export const NO_BLANK_SPACE_START_END = /^([a-zA-Z]+\s)*[a-zA-Z]+\s*$/;
export const NO_BLANK_SPACE_START_END_AND_ALPHANUMERIC = /^([A-Za-z0-9]+\s)*[A-Za-z0-9]+\s*$/;
export const NO_BLANK_SPACE_START_END_AND_ALPHANUMERIC_FOR_TIN = /^([A-Za-z0-9.-/]+\s)*[A-Za-z0-9,-/]+\s*$/;
export const CONSECUTIVE_BLANK_SPACES = /\s\s/;
export const REGEX_MAIL_VALIDATION = /^(?!.*@.*@)[a-zA-Z0-9@.]+$/;

export const SCHEME_RISK_DESCRIPTION = {
  LOW: 'Investors understand that their principal will be at low risk',
  'MODERATELY LOW': 'Investors understand that their principal will be at moderately low risk',
  MODERATE: 'Investors understand that their principal will be at moderate risk',
  'MODERATELY HIGH': 'Investors understand that their principal will be at moderately high risk',
  HIGH: 'Investors understand that their principal will be at high risk',
  'VERY HIGH': 'Investors understand that their principal will be at very high risk',
};

export const featureToggle = {
  INVEST_BASIS_RISK_PROFILE: true,
  FAQ: true,
  BANNER_CTA: true,
  NOTIFICATION_ICON: true,
  GA: true,
  INSIGHTS: true,
  BETA_FOOTER_DESCRIPTION: true,
};

export const INFLATION_RATE = 0;
export const BACK_BUTTON_MODAL_MESSAGE = 'Kindly note you will be logged out and navigated to login page.';
export const LOCK_IN_PERIOD = 3;
export const INITIATE_ACTION = {
  INVEST_BASIS_RISK_PROFILE: 'InvestBasisRiskProfile',
  INVEST_NOW: 'InvestNow',
};

export const CUST_ID = 'custId';
export const TOKEN = 'pfmToken';
export const CHANNEL_ID = 'pfmChannelId';
export const LAST_LOGIN = 'pfmLastLogin';
export const CUSTOMER_ID = 'pfmCustomerId';
export const ENCRYPTED_ID = 'encryptedId';
export const PLAN_SIP_FUND_TYPE = 'planSip';
export const CHANNEL_ID_TYPES = {
  EBNKG: 'EBNKG',
  MBK: 'MBK',
  PFM_IB: 'PFM_IB',
  PFM_MPIN: 'PFM_MPIN',
  CIB: 'CIB',
};

export const SWITCH = 'Switch';
// Removes all console logs by overriding it so that if any console logs are put accidentally in PROD
console.log = function () {};

export const SCHEME_LIST_PAGE_DISCLAIMER = [
  'Default scheme plan will be Growth. If you wish to invest in IDCW plan please visit the scheme details page.',
  'Dividend Plan is now called ‘Income Distribution cum Capital Withdrawal’ or IDCW.',
];

export const AXIS_SELECT_DISCLAIMER = [
  `The suggested funds are based on proprietary research and takes into account your profile and investment duration. Use the ‘Cart’ feature to invest in multiple funds at one go.`,
  'Default scheme plan will be Growth. If you wish to invest in IDCW plan please visit the scheme details page.',
  'Dividend Plan is now called ‘Income Distribution cum Capital Withdrawal’ or IDCW.',
];
export const FUNDS_WITH_MODERATE_TO_HIGH_RETURNS_DISCLAIMER = [
  `The suggested funds are based on proprietary research and takes into account your profile and investment duration. Use the ‘Cart’ feature to invest in multiple funds at one go.`,
  'Default scheme plan will be Growth. If you wish to invest in IDCW plan please visit the scheme details page.',
  'Dividend Plan is now called ‘Income Distribution cum Capital Withdrawal’ or IDCW.',
];

export const STOP_SIP_REASONS_CODE = {
  'Non availability of Funds': '1',
  'Non availability of Funds /Unit': 'SC1',
  'Scheme not performing': '2',
  'Scheme not performing ': 'SC2',
  'Service Issue': '3',
  'Service Issue ': 'SC3',
  'Load Revised': '4',
  'Load Revised ': 'SC4',
  'Wish to invest in other scheme': '5',
  'Wish to invest in other scheme ': 'SC5',
  'Change in Fund Manager': '6',
  'Change in Fund Manager ': 'SC6',
  'Goal Achieved': '7',
  'Goal Achieved ': 'SC7',
  'Not comfortable with market volatility': '8',
  'Not comfortable with market volatility ': 'SC8',
  'Will be restarting SIP after few months': '9',
  'Will be restarting Systematic after few months': 'SC9',
  'Modifications in bank/mandate/date etc': '10',
  'Modifications in bank/mandate/date etc ': 'SC10',
  'I have decided to invest elsewhere': '11',
  'I have decided to invest elsewhere ': 'SC11',
  'This is not the right time to invest': '12',
  'This is not the right time to invest ': 'SC12',
  Others: '13',
  'Others ': 'SC13',
};

export const STOP_SIP_HEADER = (transactionType: string) => `I wish to stop my ${transactionType} because`;
export const FUNDS_NON_AVAILABILITY = 'Non availability of Funds';
export const FUNDS_NON_AVAILABILITY_SWP = 'Non availability of Funds /Unit';
export const SCHEME_NOT_PERFORMING = 'Scheme not performing';
export const SCHEME_NOT_PERFORMING_SWP = 'Scheme not performing ';
export const SERVICE_ISSUE = 'Service Issue';
export const SERVICE_ISSUE_SWP = 'Service Issue ';
export const LOAD_REVISED = 'Load Revised';
export const LOAD_REVISED_SWP = 'Load Revised ';
export const INVEST_IN_OTHER_SCHEME = 'Wish to invest in other scheme';
export const INVEST_IN_OTHER_SCHEME_SWP = 'Wish to invest in other scheme ';
export const FUND_MANAGER_CHANGE = 'Change in Fund Manager';
export const FUND_MANAGER_CHANGE_SWP = 'Change in Fund Manager ';
export const GOAL_ACHIEVED = 'Goal Achieved';
export const GOAL_ACHIEVED_SWP = 'Goal Achieved ';
export const MARKET_VOLATILE = 'Not comfortable with market volatility';
export const MARKET_VOLATILE_SWP = 'Not comfortable with market volatility ';
export const SIP_RESTART = 'Will be restarting SIP after few months';
export const SWP_RESTART = 'Will be restarting Systematic after few months';
export const MODIFICATION = 'Modifications in bank/mandate/date etc';
export const MODIFICATION_SWP = 'Modifications in bank/mandate/date etc ';
export const INVEST_ELSEWHERE = 'I have decided to invest elsewhere';
export const INVEST_ELSEWHERE_SWP = 'I have decided to invest elsewhere ';
export const INVEST_TIME = 'This is not the right time to invest';
export const INVEST_TIME_SWP = 'This is not the right time to invest ';
export const OTHERS = 'Others';
export const OTHERS_SWP = 'Others ';

export const SESSION_EXPIRY_MESSAGE = 'Your Investments session has expired, please tap on the Home icon to proceed.';
export const LOGIN = 'LOG IN';

export const SCHEME_NOT_PERFORMING_DESCRIPTION =
  'SIP is a long term wealth creation tool, continue investing. If you wish to allocate funds in different scheme, transfer the existing holdings to new scheme of your choice.';
export const MARKET_VOLATILE_DESCRIPTION =
  'SIP is a long-term wealth creation tool. One should not get perturbed by short-term volatility in the market.<br> You may explore other categories and schemes which are less prone to market volatility.';
export const PERSONAL_USE_DESCRIPTION =
  'We hope everything is alright. Look forward to have you back soon to restart your wealth creation journey via SIP';
export const NFO_SCHEME_DETAILS_PAGE_NOTE = (
  informationCheck: string,
  liquidCutOffTimings: string,
  othersCutOffTimings: string
) => [
  'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled',
  'Allotment of Units, shall be completed not later than 5 business days after the close of the New Fund Offer Period',
  'Kindly note cut-off time for investing in NFO through Axis Bank is 5 pm on the last day of the NFO',
];

export const GUARANTEED_RETURN_PRODUCTS = 'Guaranteed Return Products';

export const MAX_LIFE_SFRD_CARD_LABEL = 'Max Life Insurance Smart fixed return plan';
export const FRSB_CARD_LABEL = 'Savings Bonds @ 7.35% interest p.a';
export const PPF_CARD_LABEL = 'Public Provident Fund (PPF) @ 7.1% interest p.a';

export const MAX_LIFE_SFRD_CARD_CONTENT = [
  'Get tax-free fixed returns up to 7.5%*',
  'Get life cover up to 11 times of premium amount, at no extra cost',
  'Enjoy tax benefit of up to Rs. 1.5 lakhs under Section 80C. Maturity amount is also exempted from capital gains tax',
  'Pay premium for 5 Years and get tax-free guaranteed maturity at the end of 5/10 years.',
];

export const MAX_LIFE_SFRD_FEATURES = [
  { icon: 'MLI', data: 'Guaranteed Tax free Returns with higher IRR (up to *7.4%)' },
  { icon: 'MLI', data: 'Significant tax benegit under section 80C and 10 10(D) of Income tax act 1961' },
  { icon: 'MLI', data: 'Enjoy higher Benefits for higher premium paid' },
  { icon: 'MLI', data: 'Life Cover equivalent to ~11 times of premium at no extra cost' },
  {
    icon: 'MLI',
    data: 'Special Benefits for women customers (0.25% additional benefit on 5 pay and 0.5% additional benefit on 10 pay',
  },
  {
    icon: 'MLI',
    data: 'Benefits of waiver of premium in case of early death, future premiums will be paid by the company',
  },
  { icon: 'MLI', data: 'Flexibility to stop paying premiums anytime after 2 years' },
];

export const FRSB_CARD_CONTENT = [
  'High interest rate: 7.35%  (subject to change every six months)',
  'Interest is paid half yearly on 1st Jan and 1st July',
  'Minimum investment: Rs. 1000; no limit on maximum investment amount',
];

export const FRSB_FEATURES = [
  { icon: 'FRSB', data: 'Risk-free investment option offered by the RBI' },
  {
    icon: 'FRSB',
    data: 'Floating interest rate: Floating interest rates ensures that investors receive interest based on the interest rates in the market',
  },
  {
    icon: 'FRSB',
    data: 'These bonds have a holding period of 7 yrs. Only senior citizens can opt for premature withdrawal',
  },
  { icon: 'FRSB', data: 'Investment in these bonds can be used as a collateral for taking loan' },
];

export const PPF_CARD_CONTENT = [
  'High interest rate: 7.1% (current interest rate)',
  'Exemption up to Rs.1.5 lakh under Section 80C ',
  'Minimum investment of Rs. 500/year, Max investment limit Rs. 1.5 lakhs/year',
  'SIP option available',
  'Instant account opening & online access to passbook module. No paperwork or branch visit required',
];

export const PPF_FEATURES = [
  { icon: 'PPF', data: 'Long-term savings instrument with investment tenure as 15 yrs' },
  {
    icon: 'PPF',
    data: 'Most tax efficient investment: Apart from claiming tax exemption under Sec 80C, interest earned and maturity amount are also exempt from capital gains tax',
  },
  { icon: 'PPF', data: 'Benefit from the power of compounding by investing every year for a period of 15 yrs' },
  { icon: 'PPF', data: 'Loan can be taken against PPF balance between the 3rd year and 5th Year' },
];

export const DISCLAIMER_LOAN_AGAINST_MF = [
  'Once you click on the ‘Get Instant loan’ option, you will be redirected to the loans journey. Request to refer to the Terms & Conditions in detail.',
  'Please note that a lien will be marked on the fund/scheme units against which the loan will be availed, and you won’t be able to redeem your holdings against that fund/scheme units.',
];

export const LOAN_AGAINST_MF_TITLE = 'Loan against Mutual Funds';
export const LOAN_AGAINST_MF_SUBTITLE = 'Avail loan against your mutual fund portfolio in easy steps.';
export const LOAN_AGAINST_MF_BUTTON = 'Get Instant loan';

export const LOAN_AGAINST_MF_HOLDINGS_DISCLAIMER = [
  'Currently your list of holdings includes the lien marked units as well. In case you have availed Loan against Mutual Funds, you won’t be able to redeem your holdings against lien marked units of that fund/scheme units. Kindly ignore if you do not have any lien marked units.',
];

export const CIB_HOLDINGS_DISCLAIMER = [
  'If you have carried out any transaction in the last 2-3 days, it will take a couple of days for the same to get reflected under your holdings.',
];
export const OWN_INVESTMENT_ID = 'Own Investment ID';
export const HUF_INVESTMENT_ID = 'HUF Investment ID';

export const DISCLAIMER_LINK = 'https://www.axisbank.com/noticeboard/importantnotice';
